import type {Country, Language, SubscriptionType} from '../types'

export const staticData = {
  countries: [] as Country[],
  languages: [] as Language[],
  subscriptionTypes: [] as SubscriptionType[]
}